import { render, staticRenderFns } from "./vision.vue?vue&type=template&id=49c910dd&scoped=true&"
import script from "./vision.vue?vue&type=script&lang=js&"
export * from "./vision.vue?vue&type=script&lang=js&"
import style0 from "./vision.vue?vue&type=style&index=0&id=49c910dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c910dd",
  null
  
)

export default component.exports